import { AppButton, Typography } from "@libs/zapi-ui/custom";
import { ProhibitIcon } from "@libs/zapi-ui/assets";
import { TIntelligenceQuestion } from "../model/types";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowSquareOutIcon, SparkleIcon } from "@phosphor-icons/react";
import { useChapterStore } from "@/zapi-frontend/stores/chapter";
import { getRouteProjectDetails } from "@/zapi-frontend/shared/const/router";
type TIQuestionProps = {
  question: TIntelligenceQuestion;
  onResearchClick: (question: TIntelligenceQuestion) => Promise<void>;
  onNAClick?: () => void;
  isLoading?: boolean;
};

export function IQuestion(props: TIQuestionProps) {
  const navigate = useNavigate();
  const { question, onNAClick, onResearchClick, isLoading } = props;

  const { setActiveChapter } = useChapterStore();
  const { id } = useParams();

  function handleResearchClick() {
    onResearchClick(question);
  }

  function handleNewChapterClick() {
    if (!question.createdProjectChapter || !id) return;
    setActiveChapter(String(question.createdProjectChapter.id));
    navigate(`${getRouteProjectDetails(id)}?tab=document&chapterId=${question.createdProjectChapter.id}`);
  }

  return (
    <div
      data-testid={`intelligence-question-${question.id}`}
      className="px-4 py-2 pb-3 border border-zinc-100 rounded-[8px] bg-white "
    >
      <Typography variant="body2" className="text-zinc-900">
        {question.text}
      </Typography>
      <div className="flex items-center gap-2 justify-between mt-2">
        {question.createdProjectChapter && (
          <AppButton
            data-testid={`intelligence-question-${question.id}-chapter-link`}
            size="sm"
            appearance="text"
            onClick={handleNewChapterClick}
          >
            <Typography variant="label3" className="inline-flex items-center gap-1">
              <ArrowSquareOutIcon className="w-3 h-3" />
              {question.createdProjectChapter.name}
            </Typography>
          </AppButton>
        )}
        {!question.createdProjectChapter && (
          <AppButton
            data-testid={`intelligence-question-${question.id}-research`}
            size="sm"
            onClick={handleResearchClick}
            isLoading={isLoading}
            loadingText="Researching..."
            startAdornment={<SparkleIcon className="w-4 h-4" />}
            className={"transition-all duration-100"}
          >
            AI Research
          </AppButton>
        )}
        {onNAClick && (
          <AppButton
            data-testid={`intelligence-question-${question.id}-na`}
            appearance="text"
            size="sm"
            onClick={onNAClick}
            className="text-zinc-500"
            disabled={isLoading}
            startAdornment={<ProhibitIcon className="w-4 h-4 text-zinc-900" />}
          >
            N/A
          </AppButton>
        )}
      </div>
    </div>
  );
}
